<template>
  <div>
    <b-card title="Filtrele">
      <b-row>
        <b-col
          md="6"
          cols="12"
        >
          <trash-bin-sdate />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <trash-bin-edate />
        </b-col>
        <b-col
          cols="12"
        >
          <trash-bin-component-select />
        </b-col>
        <b-col
          cols="6"
          md="6"
        >
          <div class="text-right">
            <b-button
              variant="primary"
              :disabled="dataLoading"
              @click="searchData"
            >
              <feather-icon
                v-if="!dataLoading"
                icon="FilterIcon"
              />
              <b-spinner
                v-if="dataLoading"
                small
              />
              Filtrele
            </b-button>
          </div>
        </b-col>
        <b-col
          cols="6"
          md="6"
        >
          <div class="text-left">
            <b-button
              variant="warning"
              :disabled="dataLoading"
              @click="resetFilter"
            >
              <feather-icon icon="TrashIcon" />
              Sıfırla
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body>
      <b-card-body>
        <b-card-title>Silinmiş Öğeler</b-card-title>
        <b-card-text>Bu alandaki öğeler belirli süre içerisinde otomatik olarak sistemden tamamen kaldırılır.</b-card-text>
      </b-card-body>
      <template v-if="dataLoading">
        <loading />
      </template>
      <template v-else>
        <b-table
          responsive="sm"
          :fields="fields"
          :items="dataList"
          striped
        >
          <template #cell(title)="data">
            {{ data.item.title }}
            <div>
              <template v-if="data.item.component === 'project_files'">
                <b-badge
                  variant="light-primary"
                  class="mr-1"
                >
                  <feather-icon icon="FolderIcon" />
                  Proje Dokümanı
                </b-badge>
              </template>
              <template v-if="data.item.component === 'service_files'">
                <b-badge
                  variant="light-primary"
                  class="mr-1"
                >
                  <feather-icon icon="FolderIcon" />
                  Hizmet Dokümanı
                </b-badge>
                <template v-if="data.item.CurrentVersion">
                  <b-badge
                    variant="light-secondary"
                    class="mr-1"
                  >
                    <feather-icon icon="TerminalIcon" />
                    {{ data.item.CurrentVersion.version }}
                  </b-badge>
                  <template v-if=" data.item.CurrentVersion.status === 'draft'">
                    <b-badge
                      variant="light-secondary"
                      class="mr-1"
                    >
                      Taslak
                    </b-badge>
                  </template>
                  <template v-if=" data.item.CurrentVersion.status === 'alpha'">
                    <b-badge
                      variant="light-warning"
                      class="mr-1"
                    >
                      Test / Alpha
                    </b-badge>
                  </template>
                  <template v-if=" data.item.CurrentVersion.status === 'released'">
                    <b-badge
                      variant="light-success"
                      class="mr-1"
                    >
                      Yayınlanmış/Kararlı
                    </b-badge>
                  </template>
                  <template v-if=" data.item.CurrentVersion.status === 'deprecated'">

                    <b-badge
                      variant="light-danger"
                      class="mr-1"
                    >
                      Kullanımdan Kaldırılmış/Eski
                    </b-badge>
                  </template>
                </template>
              </template>
              <template v-if="data.item.component === 'product_files'">
                <b-badge
                  variant="light-primary"
                  class="mr-1"
                >
                  <feather-icon icon="FolderIcon" />
                  Ürün Dokümanı
                </b-badge>
                <template v-if="data.item.CurrentVersion">
                  <b-badge
                    variant="light-secondary"
                    class="mr-1"
                  >
                    <feather-icon icon="TerminalIcon" />
                    {{ data.item.CurrentVersion.version }}
                  </b-badge>
                  <template v-if=" data.item.CurrentVersion.status === 'draft'">
                    <b-badge
                      variant="light-secondary"
                      class="mr-1"
                    >
                      Taslak
                    </b-badge>
                  </template>
                  <template v-if=" data.item.CurrentVersion.status === 'alpha'">
                    <b-badge
                      variant="light-warning"
                      class="mr-1"
                    >
                      Test / Alpha
                    </b-badge>
                  </template>
                  <template v-if=" data.item.CurrentVersion.status === 'released'">
                    <b-badge
                      variant="light-success"
                      class="mr-1"
                    >
                      Yayınlanmış/Kararlı
                    </b-badge>
                  </template>
                  <template v-if=" data.item.CurrentVersion.status === 'deprecated'">

                    <b-badge
                      variant="light-danger"
                      class="mr-1"
                    >
                      Kullanımdan Kaldırılmış/Eski
                    </b-badge>
                  </template>
                </template>
              </template>
              <template v-if="data.item.component === 'projects'">
                <b-badge
                  variant="light-primary"
                  class="mr-1"
                >
                  <feather-icon icon="FolderIcon" />
                  Proje Kartı
                </b-badge>
              </template>
              <template v-if="data.item.component === 'services'">
                <b-badge
                  variant="light-primary"
                  class="mr-1"
                >
                  <feather-icon icon="FolderIcon" />
                  Hizmet Kartı
                </b-badge>
              </template>
              <template v-if="data.item.component === 'products'">
                <b-badge
                  variant="light-primary"
                  class="mr-1"
                >
                  <feather-icon icon="FolderIcon" />
                  Ürün Kartı
                </b-badge>
              </template>
            </div>
          </template>
          <template #cell(deleted)="data">
            <b-badge variant="light-danger">
              <feather-icon icon="TrashIcon" />
              {{ moment(data.item.deleted).format('DD.MM.YYYY HH:mm:ss') }}
            </b-badge>
            <div>
              <small class="text-muted font-weight-bolder">
                <feather-icon icon="UserIcon" />
                {{ data.item.username }}
              </small>
            </div>
          </template>
          <template #cell(control)="data">
            <div class="text-right">
              <div class="mb-1">
                <b-button
                  variant="outline-success"
                  size="sm"
                  block
                  @click="recoveryData(data.item.id,data.item.component)"
                >
                  <feather-icon icon="RefreshCcwIcon" />
                  Geri Al
                </b-button>
              </div>
              <div>
                <b-button
                  variant="outline-danger"
                  size="sm"
                  block
                  @click="removeData(data.item.id,data.item.component)"
                >
                  <feather-icon icon="TrashIcon" />
                  Kalıcı Olarak Sil
                </b-button>
              </div>
            </div>
          </template>
        </b-table>
        <b-card-footer>
          <b-pagination
            v-if="dataCounts > perPage"
            v-model="currentPage"
            :total-rows="dataCounts"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </b-card-footer>
      </template>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BBadge, BCardText, BCardTitle, BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Loading from '@/layouts/components/common/Loading.vue'
import TrashBinSdate from '@/views/TrashBin/Elements/Sdate.vue'
import TrashBinEdate from '@/views/TrashBin/Elements/Edate.vue'
import TrashBinComponentSelect from '@/views/TrashBin/Elements/ComponentSelect.vue'
import listPagination from '@/mixins/listPagination'

export default {
  name: 'Index',
  components: {
    TrashBinComponentSelect,
    TrashBinEdate,
    TrashBinSdate,
    Loading,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BBadge,
    BCardText,
    BCardTitle,
    BRow,
    BCol,
    BSpinner,
  },
  mixins: [listPagination],
  data() {
    return {
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Başlık',
        },
        {
          key: 'deleted',
          label: 'Silinme Tarihi',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          'id',
          'title',
          'deleted',
          'username',
        ],
        components: [],
        sdate: null,
        edate: null,
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['trashBin/dataList']
    },
    dataCounts() {
      return this.$store.getters['trashBin/dataCounts']
    },
    dataLoading() {
      return this.$store.getters['trashBin/loading']
    },
    filterData() {
      return this.$store.getters['trashBin/filterParams']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      if (this.filterData.sdate) {
        this.dataQuery.sdate = this.filterData.sdate
      } else {
        this.dataQuery.sdate = null
      }

      if (this.filterData.edate) {
        this.dataQuery.edate = this.filterData.edate
      } else {
        this.dataQuery.edate = null
      }

      if (this.filterData.components) {
        this.dataQuery.components = this.filterData.components
      } else {
        this.dataQuery.components = []
      }
      this.filterDataList()
    },
    resetFilter() {
      this.$store.commit('trashBin/RESET_FILTER_PARAMS')
      this.searchData()
    },
    getDataList() {
      this.dataQuery.start = (this.currentPage - 1) * this.perPage
      this.$store.dispatch('trashBin/getDataList', this.dataQuery)
        .then(res => {
          if (res && res.status === false) {
            this.showToast({
              variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: res.message,
            })
            return
          }
          this.checkPageRange()
        })
    },
    // İşlem sonucunu tek bildirimle gösterir; hata durumunda backend mesajı kullanılır
    showResult(res, { successTitle, successText, closeText }) {
      const success = !!(res && res.status)
      this.$swal({
        icon: success ? 'success' : 'error',
        title: success ? successTitle : 'İşlem Hatası!',
        text: (res && res.message) || (success ? successText : 'Sistem hatası oluştu.'),
        confirmButtonText: closeText,
        customClass: {
          confirmButton: success ? 'btn btn-success' : 'btn btn-primary',
        },
      })
    },
    recoveryData(id, component) {
      this.$swal({
        title: this.$store.state.app.recoveryTitle,
        text: this.$store.state.app.recoveryMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.recoveryConfirm,
        cancelButtonText: this.$store.state.app.recoveryCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('trashBin/recoveryData', { id, component })
            .then(res => {
              this.showResult(res, {
                successTitle: this.$store.state.app.recoveryResultTitle,
                successText: this.$store.state.app.recoveryResultMessage,
                closeText: this.$store.state.app.recoveryResultClose,
              })
              this.getDataList()
            })
        }
      })
    },
    removeData(id, component) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('trashBin/removeData', { ids: id, components: component })
            .then(res => {
              this.showResult(res, {
                successTitle: this.$store.state.app.removeResultTitle,
                successText: this.$store.state.app.removeResultMessage,
                closeText: this.$store.state.app.removeResultClose,
              })
              this.getDataList()
            })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
